import { render, staticRenderFns } from "./appRiskReport.vue?vue&type=template&id=28af2604"
import script from "./appRiskReport.vue?vue&type=script&lang=js"
export * from "./appRiskReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports